export const attachmentViewerStyles = {
	backdrop: {
		position: 'fixed',
		inset: 0,
		backgroundColor: 'rgba(0, 0, 0, 0.85)',
		zIndex: 1400,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	},
	imageStage: (isDragging: boolean, zoom: number) => ({
		position: 'relative',
		width: '100%',
		height: '100%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		overflow: 'hidden',
		cursor: zoom > 1 ? (isDragging ? 'grabbing' : 'grab') : 'default',
		userSelect: 'none'
	}),
	image: (zoom: number, offsetX: number, offsetY: number) => ({
		maxWidth: '90vw',
		maxHeight: '90vh',
		translate: `${offsetX}px ${offsetY}px`,
		scale: String(zoom),
		objectFit: 'contain'
	}),
	topBar: {
		position: 'absolute',
		top: 0,
		left: 0,
		right: 0,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		p: 2,
		color: 'common.white',
		zIndex: 1
	},
	filename: {
		fontSize: '0.875rem',
		fontWeight: 500,
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		flex: 1,
		mr: 2
	},
	counter: {
		fontSize: '0.75rem',
		color: 'rgba(255,255,255,0.7)',
		mr: 2
	},
	iconButton: {
		color: 'common.white',
		backgroundColor: 'rgba(0, 0, 0, 0.4)',
		'&:hover': {
			backgroundColor: 'rgba(0, 0, 0, 0.6)'
		}
	},
	navButton: (side: 'left' | 'right') => ({
		position: 'absolute',
		[side]: 16,
		top: '50%',
		transform: 'translateY(-50%)',
		color: 'common.white',
		backgroundColor: 'rgba(0, 0, 0, 0.4)',
		'&:hover': {
			backgroundColor: 'rgba(0, 0, 0, 0.6)'
		}
	})
};
